import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { ListObservable } from '../../shared/base/list-observable';
import { Lecture } from '../shared/lecture';
import { LectureUserService } from '../shared/lecture-user.service';

@Component({
  selector: 'app-lecture-member-list',
  templateUrl: './lecture-member-list.component.html'
})
export class LectureMemberListComponent implements OnChanges {
  @Input() lecture: Lecture;
  usersObservable: ListObservable<any>;

  constructor(private refService: LectureUserService) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['lecture']) {
      this.usersObservable = this.refService.readList(this.lecture.$key);
    }
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lectures/lecture-member-list/lecture-member-list.component.ts